<template>
  <el-popover :visible="popoverVisible" placement="bottom" trigger="click">
    <el-checkbox-group :model-value="checkbox" @update:model-value="onChange">
      <template v-for="column in data" :key="column.prop">
        <el-checkbox :label="column.prop">{{ column.label }}</el-checkbox>
      </template>
      <el-checkbox v-show="showSelection" label="selection" key="selection">{{
        t('el.cigTable.selection')
      }}</el-checkbox>
      <el-checkbox v-show="showIndex" label="index" key="index">{{
        t('el.cigTable.index')
      }}</el-checkbox>
    </el-checkbox-group>
    <div class="cig-table-check-btn">
      <el-button class="btn-del" size="small" @click="popoverCancel">{{
        t('el.cigTable.cancel')
      }}</el-button>
      <el-button size="small" type="primary" @click="popoverOk">
        {{ t('el.cigTable.confirm') }}
      </el-button>
    </div>
    <template #reference>
      <template v-if="mode === 'inline'">
        <el-button
          :icon="IconCog"
          class="el-popover-column"
          size="small"
          @click="popoverClick"
        ></el-button>
      </template>
      <template v-else>
        <el-button type="primary" @click="popoverClick">
          {{ t('el.cigTable.columns') }}
          <el-icon
            :class="['cig-icon--right', { 'is-change': popoverVisible }]"
          >
            <arrow-down />
          </el-icon>
        </el-button>
      </template>
    </template>
  </el-popover>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { IconCog } from '@park-ui/components/cig-icon'
import {
  CheckboxValueType,
  ElButton,
  ElCheckbox,
  ElCheckboxGroup,
  ElIcon,
  ElMessage,
  ElPopover,
} from '@park-ui/components'
import { ArrowDown } from '@element-plus/icons-vue'
import { useLocale } from '@park-ui/hooks'
import { columnPopoverProps } from './popover'

export default defineComponent({
  name: 'ElColumnPopover',
  props: columnPopoverProps,
  emits: ['update:checkbox', 'cancel', 'ok'],
  components: {
    ElButton,
    ElCheckbox,
    ElCheckboxGroup,
    ElIcon,
    ElPopover,
    ArrowDown,
  },
  setup(props, { emit, expose }) {
    const { t } = useLocale()
    const popoverVisible = ref(false)

    const popoverClick = () => {
      popoverVisible.value = true
    }
    const popoverCancel = () => {
      hide()
      emit('cancel')
    }
    const popoverOk = () => {
      hide()
      emit('ok')
    }

    const onChange = (val: Array<CheckboxValueType>) => {
      const propCheck = val.filter((x: any) =>
        props.data.map((x) => x.prop).includes(x)
      )
      if (propCheck.length === 0 && val.length <= 2) {
        if (!val.includes('index')) {
          return ElMessage.warning(t('el.cigTable.popoverTips'))
        } else {
          emit('update:checkbox', val)
        }
      } else {
        emit('update:checkbox', val)
      }
    }

    const hide = () => {
      popoverVisible.value = false
    }
    expose({
      popoverVisible,
      hide,
    })
    return {
      IconCog,
      popoverCancel,
      popoverOk,
      popoverClick,
      popoverVisible,
      t,
      onChange,
    }
  },
})
</script>
